const STATINSP_UPDATEDPLANTSWITHOUTSTATINSP = (
  state,
  plantsWithoutStatInsp
) => {
  state.plantsWithoutStatInsp = plantsWithoutStatInsp;
};

const STATINSP_UPDATEDSTATINSPS = (state, statInsps) => {
  state.statInsps = statInsps;
};

const STATINSP_SETSTATINSP = (state, statInsp) => {
  state.statInsp = statInsp;
};

const STATINSP_SETSTATINSPITEM = (state, statInspItem) => {
  state.statInspItem = statInspItem;
};

const STATINSP_UPDATESTATINSPITEMS = (state, statInspItems) => {
  state.statInspItems = statInspItems;
};

const STATINSP_UPDATEPAGESSTATINSPITEMS = (state, statInspItemResults) => {
  state.statPagedInspItems = statInspItemResults;
};

export default {
  STATINSP_UPDATEDPLANTSWITHOUTSTATINSP,
  STATINSP_UPDATEDSTATINSPS,
  STATINSP_SETSTATINSP,
  STATINSP_SETSTATINSPITEM,
  STATINSP_UPDATESTATINSPITEMS,
  STATINSP_UPDATEPAGESSTATINSPITEMS
};
